<template>
  <div>
  <v-row class="primary align-center mtfont hidden-sm-and-down">
    <v-col cols="12">
      <div
        class="d-flex align-center ml-2"
      >
        <span class="mb-3">
          PANTONE COATED COLOR:
        </span>

        <v-autocomplete
          id="colorSelect"
          :items="colors"
          v-model="color"
          item-text="code"
          style="max-width: 200px;"
          item-color="accent"
          color="accent"
          class="mx-2 mt-4"
          outlined
          dense
        ></v-autocomplete>


        <v-text-field
          class="mx-2 mt-4"
          v-model="grams"
          outlined
          color="accent"
          style="max-width: 150px;"
          suffix="grams"
          dense
        ></v-text-field>
        <v-btn
          depressed
          color="black"
          style="color: #fecb39;"
          large
          class="mb-3"
          v-on:click="selectColor"
        >LOAD FORMULA</v-btn>
      </div>
    </v-col>
    <v-col cols="5"></v-col>
  </v-row>
  <span class="hidden-md-and-up">
    <v-row dense class="primary mtfont px-2 pt-2">
      <span class="mr-3">
        For an optimized mixing experience visit this page on desktop.
      </span>
    </v-row>
    <v-row dense class="primary mtfont px-2 pt-2">
      <v-col>
            <span class="mr-3">
              PANTONE:
            </span>
           <v-autocomplete
              id="colorSelect"
              :items="colors"
              v-model="color"
              item-text="code"
              style="max-width: 200px;"
              item-color="accent"
              color="accent"
              class="mx-2 mt-4"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
    </v-row>
    <v-row dense class="primary mtfont px-2 pt-2">
      <v-col>
        <v-row dense class="primary mtfont ">
      <v-col>
        <v-text-field
                v-model="grams"
                outlined
                color="accent"
                suffix="grams"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row  dense class="primary align-center mtfont">
      <v-col >
        <v-btn
                depressed
                color="black"
                style="color: #fecb39;"
                large
                v-on:click="selectColor"
        >LOAD FORMULA</v-btn>
      </v-col>
    </v-row>
      </v-col>
        <v-col>
        <LighteningBoltIndicater height="15vh" width="100%" />
      </v-col>
    </v-row>
  </span>
</div>
</template>


<script>
  import LighteningBoltIndicater from '@/components/Mixer/LighteningBoltIndicater.vue';

  export default {
    name: 'FormulaBar',

    components: {
      LighteningBoltIndicater
    },

    data: () => ({
      colors: [],
      grams: '100',
      color: ''
    }),
    methods: {
      selectColor: function(event) {
        const selectedColor = this.colors.find(color => color.code === this.color);
        this.$store.dispatch('setCurrentColor', {id: selectedColor.id, grams: this.grams});
      }
    },
    created() {
      this.$store.dispatch('setAllColors')
        .then(() => {
          this.color = this.$store.getters.getCurrentColor.code;
          this.colors = this.$store.getters.getAllColors;
        });
    },
    mounted() {
    }
  }
</script>

<style>
.v-text-field__suffix {
  border-left: 1px solid #000;
}
</style>